import request from '@/utils/request'

// v80ReqTime
export function v80ReqTime(param) {
  let data = param
  return request({
    url: `/inspection/v80a1070/v80ReqTime`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// v80a1070List
export function v80a1070List(param) {
  let data = param
  return request({
    url: `/inspection/v80a1070/v80a1070List`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// v80a1070Save
export function v80a1070Save(param) {
  let data = param
  return request({
    url: `/inspection/v80a1070/v80a1070Save`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
